import {SET_ERRORS, DELETE_ERROR_FOR_INPUT, CLEAR_ERRORS} from '../actions/types';

const initialState = {}

export function errors(state = initialState, action = {}) {
    switch (action.type) {
        case SET_ERRORS:
            return Object.assign({}, state, action.errors);
        case DELETE_ERROR_FOR_INPUT:
            const newState = state;
            delete newState[action.inputName];
            return newState;
        case CLEAR_ERRORS:
            return initialState;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/errors.js